export default __webpack_public_path__ + "static/media/photo_gallery_6.53a97d6d.png";